import { ChevronDownIcon } from "@primer/octicons-react";
import { Button, SelectPanel } from '@primer/react';
import { useMemo, useState } from 'react';
import { useCommonContext } from '../../contexts/common';

interface ICoSoItem {
    id: number;
    ten_co_so: string;
}

interface IComboboxCoSoProps {
    isReadonly?: boolean;
    value?: number;
    onValueChanged: (id: number, data?: any) => void;
    className?: string;
    isShowClearButton?: boolean;
    preText?: string;
    width?: string | number;
    stylingMode?: 'outlined' | 'filled' | 'underlined';
    coSoList: ICoSoItem[];
}

const ComboboxCoSo = (props: IComboboxCoSoProps) => {
    const [open, setOpen] = useState(false)
    const [filter, setFilter] = useState('')

    const { translate } = useCommonContext();
    
    const dataSource = useMemo(() => {
        return props.coSoList.map(x => ({ id: x.id, text: x.ten_co_so }))
    }, [props.coSoList])
    
    const filteredItems = useMemo(() => {
        return dataSource.filter(item => item.text.toLowerCase().includes(filter.toLowerCase()))
    }, [dataSource, filter])
    
    const selected = useMemo(() => {
        return dataSource.find(x => x.id === props.value)
    }, [dataSource, props.value])

    const setSelected = (selecteds: any) => {
        if (selecteds)
            props.onValueChanged(selecteds.id)
    }

    return (
        <SelectPanel
            renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
                <Button
                    trailingAction={ChevronDownIcon}
                    aria-labelledby={` ${ariaLabelledBy}`} {...anchorProps}
                    sx={{
                        width: props.width || '100%'
                    }}
                    className="button-left"
                    disabled={props.isReadonly}
                >
                    <p style={{ maxWidth: '100%', overflow: "hidden", textOverflow: "ellipsis" }}>
                        {children || translate("Chọn cơ sở")}
                    </p>
                </Button>
            )}

            title={""}
            placeholderText="Search"
            open={open}
            onOpenChange={setOpen}
            items={filteredItems}
            selected={selected}
            onSelectedChange={setSelected}
            onFilterChange={setFilter}
            showItemDividers={true}
            overlayProps={{ width: 'small', height: 'medium' }}
        />
    );
};

export default ComboboxCoSo;
